import styled from 'styled-components'

export const StyledCircleCheckIconWrapper = styled.div`
  display: inline-block;
  margin-right: 15px;
`
